unable to read source [project]/workspace/frontend/src/index.ts